var numberOfItems = 0;

$(document).ready(function(){

	$('#matrix1').bxSlider({
		minSlides: 6,
		maxSlides: 6,
		slideWidth: 90,
		slideMargin: 0,
		infiniteLoop: false,
		hideControlOnEnd: true,
		pager:false
	 });
	
	$('#matrix2').bxSlider({
		minSlides: 6,
		maxSlides: 6,
		slideWidth: 90,
		slideMargin: 0,
		infiniteLoop: false,
		hideControlOnEnd: true,
		pager:false
	 });
	
});




function filterByOperatorName(operatorName) {
	
	operatorName = operatorName.replace(/ /g,"");
	
	resetAllFilterInputs();
	$(".departureFlight,.returnFlight").prop("checked",false);
	
	$(".searchFilterAirline").not("#cb" + operatorName).prop("checked",false);
	$(".searchFilterAirline").filter("#cb" + operatorName).prop("checked",true);
	
	searchFilter();
	
}

function filterByTransferCount(transferCount) {
	
	resetAllFilterInputs();	
	$(".departureFlight,.returnFlight").prop("checked",false);
	
	$(".dTransferCount").not("#filterByTransfer" + transferCount).prop("checked",false);
	$(".dTransferCount").filter("#filterByTransfer" + transferCount).prop("checked",true);
	searchFilter();

}

function filterByFlightID(strID){
	
	openLoaderBox();
	
	resetAllFilterInputs();	
	$(".departureFlight,.returnFlight").prop("checked",false);
	$flightList.attr("data-visible","false");
	
	var idList = strID.split(";");
	var idValues;
	
	idValues = idList[0].split("_");
	$("[flightId='" + idValues[0] + "'][fareIndex='" + idValues[1] + "']").find(".departureFlight").prop("checked",true);
		
	if(idList.length > 1){
		idValues = idList[1].split("_");
		$("[rFlightId='" + idValues[0] + "'][rFareIndex='" + idValues[1] + "']").find(".returnFlight").prop("checked",true);
		
		$flightList.has(".departureFlight:checked").has(".returnFlight:checked").attr("data-visible","true");
	} else {
		$("[flightId='" + idValues[0] + "'][fareIndex='" + idValues[1] + "']").attr("data-visible","true");
	}
	
	pageIndex = 0;
	refreshTable();
	
	closeLoaderBox();
}

function removeFilter(){
	
	openLoaderBox();
	
	resetAllFilterInputs();	
	$(".departureFlight,.returnFlight").prop("checked",false);
	$flightList.attr("data-visible","true");
	
	pageIndex = 0;
	refreshTable();
	
	closeLoaderBox();
	
}

